// extracted by mini-css-extract-plugin
export default {"fondoOscuro":"Loader_fondoOscuro__lxOz+","imagen-blanca":"Loader_imagen-blanca__O4z6p","loader":"Loader_loader__ukxNT","rotation":"Loader_rotation__fLtzh"};